import { MIN_Y, MAX_HEIGHT } from "../constants.js";
import { ellipseWeight, visit, writeHeight } from "./mask.js";

function clampHeight(height) {
    return Math.max(MIN_Y, Math.min(MAX_HEIGHT, Math.round(height)));
}

export default function applyDunes(heights, resolution, layoutSize, feature, noise) {
    const frequency = feature.params?.frequency ?? 5;
    const strength = feature.strength ?? 1;

    visit(feature, resolution, layoutSize, (idx, u, v) => {
        const weight = ellipseWeight(u, v, noise, feature.seed);
        if (weight <= 0) return;

        const warp = noise.noise2(u * 1.4 + feature.seed * 0.01, v * 0.4) * 0.18;
        const ridge = 1 - Math.abs(Math.sin((v * frequency + warp) * Math.PI));
        writeHeight(heights, idx, clampHeight(heights[idx] + feature.height * ridge * weight * strength));
    });
}
